export default __webpack_public_path__ + "assets/img/7f1bcfa0704c85dd20bfa4a49c64878e.png";